"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import type { ColumnFiltersState } from "@tanstack/react-table";
export default function useTableColumnFilters(t0) {
  const $ = _c(10);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? [] : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const initialState = t1;
  const [columnFilters, setColumnFilters] = useState(initialState);
  let t2;
  if ($[2] !== columnFilters) {
    t2 = id => columnFilters.find(filter => filter.id === id)?.value;
    $[2] = columnFilters;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const getColumnFilter = t2;
  let t3;
  if ($[4] !== columnFilters) {
    t3 = (id_0, value) => setColumnFilters([...columnFilters.filter(filter_0 => filter_0.id !== id_0), ...(value !== undefined ? [{
      id: id_0,
      value
    }] : [])]);
    $[4] = columnFilters;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const setColumnFilter = t3;
  let t4;
  if ($[6] !== columnFilters || $[7] !== getColumnFilter || $[8] !== setColumnFilter) {
    t4 = {
      columnFilters,
      setColumnFilters,
      getColumnFilter,
      setColumnFilter
    };
    $[6] = columnFilters;
    $[7] = getColumnFilter;
    $[8] = setColumnFilter;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}